export default __webpack_public_path__ + "static/media/03_foster.99769578.gif";